import React from 'react';
import styled from 'styled-components';
import { SPACING } from '../../styles/spacing';
import { mainTheme } from '@plecto/ui';

const StyledBottomBar = styled.div`
	z-index: 90;
	position: fixed;
	left: 0;
	bottom: 0;
	width: 100%;
	background-color: ${mainTheme.surface[2]};
	border-top: 1px solid ${mainTheme.border.decorative};
	box-shadow: 0 0 6px rgba(0, 0, 0, 0.36);
	text-align: right;
	padding: ${SPACING.small} ${SPACING.big};
	transition: margin-left .2s;
`;

export default function BottomBar({ children }) {
	return <StyledBottomBar className={'bottom-bar'}>
		{children}
	</StyledBottomBar>;
}
